const unregisterListener = (event: string, fn: Function, Object: any = window) => {
    if (Object.removeEventListener)
        Object.removeEventListener(event, fn)
    else
        Object.detachEvent('on' + event, fn)
}

export default unregisterListener
